import { RiskModelsWrapper } from "./risk-models-wrapper";

export default function RiskModelsPage() {
  return <RiskModelsWrapper />;
}
